<template>
  <block class="detail-body-last">
    <div class="buy-ok-wrap" v-if="isPayed">
      <div class="buy-ok-body">
        <h2>恭喜您，抢购成功</h2>
        <dl class="order-info">
          <dt>您的订单：{{goods.goodsName}}</dt>
          <dd>金额：{{goods.shopPrice}}</dd>
          <dd>购买时间：xxxx</dd>
          <dd>斗K权限有效期：xxxx - xxxx</dd>
        </dl>
        <div class="buy-ok-btns">
          <van-row gutter="15">
            <van-col span="12">
              <van-button type="danger" size="normal" block>开始训练</van-button>
            </van-col>
            <van-col span="12">
              <van-button type="warning" size="normal" block>立即下载</van-button>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div class="detail-body__buy" v-else>
      <goods-button-buy :goods-id="goodsId" />
    </div>
  </block>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';

  export default {
    data() {
      return {

      }
    },
    props: ['goodsId'],
    computed: {
      ...mapGetters(['waitLastId', 'goodsInfo', 'leftSecsPre',
        'leftSecsBegin',
        'leftSecsEnd',
        'sec2txt',
        'toPreId'
      ]),
      goods() {
        return this.goodsInfo(this.goodsId)
      },
      isPayed() {
        return this.$store.getters.isPayed(this.goodsId)
      },
      isPre() {
        return this.$store.getters.isPre(this.goodsId)
      },
      isLast() {
        return this.$store.getters.isLast(this.goodsId)
      }
    },
    beforeUpdate() {
      // alert(this.isPayed)
      // if (!this.isPayed) {
      //   // alert('11')
      //   const preId = this.toPreId(this.goodsId)
      //   if (preId > 0) {
      //     this.$router.push(`/goods/${preId}`)
      //   } else {
      //     // this.$router.replace('/index')
      //   }
      // }
    }
  }

</script>
